import React, { useEffect, useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Legend, Tooltip, ResponsiveContainer, BarChart, Bar, LineChart, Line } from "recharts";
import { useNavigate } from 'react-router-dom';
import { useSentimentAnalysisApi } from '../../store/api/hooks/sentimentAnalysisApiHook';
import { useAuthStatus, useStoreSelector, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { toast } from 'react-hot-toast';
import moment from 'moment';
import Spinner from '../../components/iconSvgs/spinner';
import { SentimentComparisonResponse, PrevSentimentComparisonResponse, CurrSentimentComparisonResponse } 
from '../../_config/interfaces/interfaces';
import { formatDate } from '../../_common/functions';


const SentimentComparison = ({ filterValue }: { filterValue: any; }) => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [sentimentComp, setSentimentComp] = useState<SentimentComparisonResponse>({
        comp_frequency: { current_comp_node: '', previous_comp_node: '' },
        previous_comp_node: [],
        current_comp_node: []
    });
    const [showMonth, setShowMonth] = useState(false);

    const sentimentAPI: any = useSentimentAnalysisApi();
    const navigate = useNavigate();
    const isAuth = useAuthStatus();
    const branchDS = useStoreBrnDSSelector();
    // console.log('useEffect =>', branchDS);

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue);
        } else {
            geSentimentComparison({});
        }
    }, [filterValue, showMonth]);

    const applyFilter = (filterValue: any) => {
        geSentimentComparison(filterValue);
    }

    const geSentimentComparison = (param: any) => {
        // console.log(param)
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = { branch_id: branchDS?.branch_id, comparison_frequency: showMonth ? 'yearly' : 'monthly' };
        } else {
            params = { branch_id: branchDS?.branch_id, comparison_frequency: showMonth ? 'yearly' : 'monthly', ...param };
        }
        try {
            setTimeout(() => {
                sentimentAPI.getSentimentComparison(params, (msg: any, resp: any) => {
                    // console.log('response =>', resp, msg);
                    setSentimentComp(resp?.data);
                }, (err: any, resp: any) => {
                    toast.error(resp?.detail?.message);
                })
                setOnSubmitLoading(false);
            }, 3000);

        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    }

    const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // console.log('showMonth =>', showMonth, e.target.value, e.target.checked);
        // showMonth = e.target.checked;
        setShowMonth(e.target.checked);

        let params: any;
        if (filterValue) {
            params = {
                branch_id: branchDS?.branch_id, comparison_frequency: showMonth ? 'yearly' : 'monthly', ...filterValue
            };
        } else {
            params = {
                branch_id: branchDS?.branch_id, comparison_frequency: showMonth ? 'yearly' : 'monthly'
            };
        }
        geSentimentComparison(params)
    };


    const getFullMonthName = (value: string) => {
        const monthMap: { [key: string]: string } = {
            Jan: "January",
            Feb: "February",
            Mar: "March",
            Apr: "April",
            May: "May",
            Jun: "June",
            Jul: "July",
            Aug: "August",
            Sep: "September",
            Oct: "October",
            Nov: "November",
            Dec: "December"
        };

        return monthMap[value] || value;
    };



    const isMonth = (value: string) => {
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        return months.includes(value);
    };


    const isYear = (value: string) => {
        const yearRegex = /^[12][0-9]{3}$/;
        return yearRegex.test(value);
    };

    /* const getXAxisDataKey = (value: string) => {
        // console.log('value =>', value);
        if (isMonth(value)) {
            return "date";
        } else if (isYear(value)) {
            return "month";
        }
        return ""; // Default or error case, in case neither month nor year
    }; */
    //const xAxisDataKey = getXAxisDataKey(sentimentComp.comp_frequency.previous_comp_node);


    useEffect(() => {
      console.log('sentimentComp =>', sentimentComp?.current_comp_node);
    }, [sentimentComp]);

    return (
      <>
        {isOnSubmitLoading && (
          <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
            <Spinner className="self-center z-50" />
          </div>
        )}
        {/* {sentimentComp?.reviews_by_date.length > 0 && ( */}
        <div className="bg-white shadow-lg rounded-2xl p-6 mb-5 flex-1">
          <div className="flex justify-between items-center mb-4 mobile-column">
            <h1 className="text-base font-semibold text-gray-500">
              Sentiment Comparison
            </h1>

            <div className="flex items-center space-x-2">
              <p className="text-sm text-gray-500">Comparison Frequency</p>
              <label className="flex items-center cursor-pointer">
                <span className="mr-2 text-gray-500">Monthly</span>
                <input
                  type="checkbox"
                  checked={showMonth}
                  onChange={handleToggleChange}
                  // onChange={(e) => { handleToggleChange(e) }}
                  className="toggle-checkbox"
                />
                <span className="ml-2 text-sm text-gray-500">
                  Yearly
                  {/* {showMonth ? "Yearly" : "Monthly"} */}
                </span>
              </label>
            </div>
          </div>

          {/* Container for the two charts */}
          <div className="flex space-x-4 mb-5 mobile-column">
            {/* First chart */}
            <div className="flex-1">
              {/* getFullMonthName(sentimentComp?.comp_frequency?.previous_comp_node) */}
              <p className="text-base text-gray-500 mb-4">
                {getFullMonthName(
                  sentimentComp?.comp_frequency?.previous_comp_node
                )}
              </p>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={730}
                  height={250}
                  data={sentimentComp?.previous_comp_node}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey={showMonth ? 'month' : 'date'} tickFormatter={(value) => {
                    return showMonth ? value : formatDate(value);
                  }} />
                  <YAxis
                    tickFormatter={(value) => (value % 1 === 0 ? value : "")}
                    domain={[
                      0,
                      Math.max(
                        ...sentimentComp?.previous_comp_node?.map(
                          (item) =>
                            item?.positive +
                            item?.negative
                        )
                      ),
                    ]} // Manually setting the max value for scaling
                    tickCount={5}
                  />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="negative" stroke="#f87171" strokeWidth={2} />
                  <Line type="monotone" dataKey="positive" stroke="#82ca9d" strokeWidth={2} />
                </LineChart>
              </ResponsiveContainer>
            </div>

            {/* Second chart */}
            <div className="flex-1">
              <p className="text-base text-gray-500 mb-4">
                {getFullMonthName(
                  sentimentComp?.comp_frequency?.current_comp_node
                )}
              </p>
              <ResponsiveContainer width="100%" height={300}>
              <LineChart
                  width={730}
                  height={250}
                  data={sentimentComp?.current_comp_node}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey={showMonth ? 'month' : 'date'} tickFormatter={(value) => {
                    return showMonth ? value : formatDate(value);
                  }} />
                  <YAxis
                    tickFormatter={(value) => (value % 1 === 0 ? value : "")}
                    domain={[
                      0,
                      Math.max(
                        ...sentimentComp?.current_comp_node?.map(
                          (item) =>
                            item?.positive +
                            item?.negative
                        )
                      ),
                    ]} // Manually setting the max value for scaling
                    tickCount={5}
                  />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="negative" stroke="#f87171" strokeWidth={2} />
                  <Line type="monotone" dataKey="positive" stroke="#82ca9d" strokeWidth={2} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </>
    );
}

export default SentimentComparison;